import React from 'react';
import logo from './logo.svg';
import './App.css';
import { config } from './appConfig'

import {
  ThemeProvider,
  createTheme,
} from '@mui/material/styles'

import CssBaseline from '@mui/material/CssBaseline'

// import MapComponent from './components/content/Map'
import HomePage from './app/pages/HomePage'
import { AuthFunc } from './app/auth/auth';
import "https://js.arcgis.com/calcite-components/3.3.3/calcite.esm.js"
import AppRoutes from './app/routes/AppRoutes';
import theme from './theme';


// const darkTheme = createTheme({
//   palette: {
//     mode: 'dark',
//   },
// });
// const theme = createTheme({
//   typography: {
//     fontSize: 12,
//   },
// });
function App() {
  AuthFunc()
  return (
    <ThemeProvider theme={theme}>
      {/* <CssBaseline /> */}
      <AppRoutes />
    </ThemeProvider>
    // <div id='webmap'>
    //   <MapComponent mapItem={config.mapItemId}/>
    // </div>
    // </ThemeProvider>
  );
}

export default App;
